import { render, staticRenderFns } from "./StandardInput.vue?vue&type=template&id=a8c47bfa&lang=pug&"
import script from "./StandardInput.vue?vue&type=script&lang=js&"
export * from "./StandardInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports